var map = {
	"./dataView.vue": "klBO",
	"./description.vue": "OZwJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0+4p";


//////////////////
// WEBPACK FOOTER
// ./src/components/dataViews \.(js|vue)$/
// module id = 0+4p
// module chunks = 1